import PageHeader from "@/components/PageHeader";
import TimeSummary from "@/components/TimeSummary";

export default function TimeTracking() {
  return (
    <div data-testid="time-tracking-page">
      <PageHeader title="Time Tracking" subtitle="Every tracked work session across your properties — start or stop a timer on any product" testid="time-tracking-header" />
      <div className="p-6 md:p-8">
        <TimeSummary testid="time-tracking-summary" showStats />
      </div>
    </div>
  );
}
